import { PromotionsHighlights } from '@vpp-frontend-components/promotions';

export default PromotionsHighlights;
